import { Box } from '@/src/packages/components/ui/Box';
import { IFetchBundleSchema, StockLevels } from '@bitmap/contracts';
import { Button } from '@/src/packages/components/ui/Button';
import Link from 'next/link';
import { getRoute } from '@/src/packages/utils/routes';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { Paragraph } from '@/src/packages/components/ui/Paragraph';
import { Heading } from '@/src/packages/components/ui/Heading';
import { Stack } from '@/src/packages/components/ui/Stack';
import { useBundleContext } from '@/src/packages/components/pages/Bundle/BundleContext';
import { ProductImageCarousel } from '@/src/packages/components/pages/Product/ProductImage';
import { getProductTitle } from '@/src/app/(base)/products/[slug]/utils/getProductTitle';

export const BundleProduct = ({
  productVariant,
}: {
  productVariant: IFetchBundleSchema['variants'][0];
}) => {
  const { handleOpenModal, bundle } = useBundleContext();

  return (
    <Box
      className="grid grid-cols-12 gap-4 lg:gap-0"
      id={productVariant.id.toString()}
    >
      <Box className="order-1 col-span-12 lg:order-1 lg:col-span-6">
        <ProductImageCarousel
          title={getProductTitle(
            productVariant.product.title,
            productVariant.productOptionValue.name,
          )}
          images={productVariant.images}
        />
      </Box>
      <Box className="order-2 col-span-12 flex flex-col items-center justify-center lg:order-2 lg:col-span-6 lg:p-8">
        <Box className="w-full space-y-5 lg:max-w-lg">
          <Box className="space-y-2">
            <Heading as="h2" className="font-serif text-3xl">
              {productVariant.product.title}
            </Heading>

            <Paragraph>{productVariant.description}</Paragraph>
          </Box>

          <Stack spaceY={3}>
            {bundle.stockLevel !== StockLevels.out_of_stock ? (
              <Button isBlock={true} variant="solid" onClick={handleOpenModal}>
                Select options
              </Button>
            ) : (
              <Button isBlock={true} variant="solid" disabled>
                Out of stock
              </Button>
            )}

            <Button isBlock={true} asChild>
              <Link
                href={getRoute({
                  route: paths.PRODUCTS_SINGLE,
                  params: { [pathParams.PRODUCT_SINGLE]: productVariant.slug },
                })}
              >
                View product details
              </Link>
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
